import { render, staticRenderFns } from "./ServiceProvidersPromotions.vue?vue&type=template&id=87813524&scoped=true&"
import script from "./ServiceProvidersPromotions.vue?vue&type=script&lang=ts&"
export * from "./ServiceProvidersPromotions.vue?vue&type=script&lang=ts&"
import style0 from "./ServiceProvidersPromotions.vue?vue&type=style&index=0&id=87813524&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "87813524",
  null
  
)

export default component.exports